var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    [
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki_sekininsya.sei"
          ),
          "detail-value": [_vm.form["officeInfoRequestPersonLastName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki_sekininsya.mei"
          ),
          "detail-value": [_vm.form["officeInfoRequestPersonFirstName"]]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki_sekininsya.name_kana"
          ),
          "detail-value": [
            _vm.form["officeInfoRequestPersonKanaLastName"] +
              " " +
              _vm.form["officeInfoRequestPersonKanaFirstName"]
          ]
        }
      }),
      _vm._v(" "),
      _c("detail-data-single-label", {
        attrs: {
          "detail-label": _vm.$t(
            "view.sales_force.reflect.label.torihikisaki_sekininsya.mail"
          ),
          "detail-value": [_vm.form["officeInfoRequestEmail"]]
        }
      }),
      _vm._v(" "),
      !_vm.readonlyMode
        ? _c(
            "v-row",
            { staticClass: "mt-3" },
            [
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                  attrs: { cols: "12", sm: "12", md: "4" }
                },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pt-3 pb-3 align-center fixed-label-area",
                      attrs: { color: "grey lighten-3" }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 font-weight-bold ml-4 fixed-label"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "view.sales_force.reflect.label.torihikisaki_sekininsya.id"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pt-2 pb-0",
                  attrs: { cols: "12", sm: "8", md: "4" }
                },
                [
                  _c("ValidationProvider", {
                    attrs: { vid: "applyTorihikisakiId", rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(checked) {
                            return [
                              _c("v-text-field", {
                                staticClass: "mt-0 pt-0 pb-0",
                                attrs: {
                                  "persistent-hint": "",
                                  hint: _vm.$t(
                                    "view.sales_force.reflect.hint.torihikisaki_sekininsya.id"
                                  ),
                                  placeholder: _vm.$t(
                                    "view.sales_force.reflect.placeholder.torihikisaki_sekininsya.id"
                                  ),
                                  autocomplete: "off"
                                },
                                model: {
                                  value: _vm.salesForceInfo.applyTorihikisakiId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.salesForceInfo,
                                      "applyTorihikisakiId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "salesForceInfo.applyTorihikisakiId"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2898176916
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                  attrs: { cols: "12", sm: "4", md: "4" }
                },
                [
                  _c("move-sales-force-button", {
                    attrs: {
                      "sales-force-id": _vm.salesForceInfo.applyTorihikisakiId,
                      "sales-force-type": "Contact"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.readonlyMode
        ? _c("sales-force-button-area", {
            on: {
              reflect: _vm.submit,
              "csv-output": _vm.csvOutput,
              "re-correct": _vm.reCorrect
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.alert_torihikisaki_id"
          )
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4dc2f7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4dc2f7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/TorihikisakiSekininsyaApply.vue
// module id = QVpd
// module chunks = 1